
import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ServerService } from '../../service/server/server.service';
import { ModulesComponent } from '../../service/modules/modules.component';

@Component({
  selector: 'app-sale-search',
  templateUrl: './sale-search.component.html',
  styleUrls: ['./sale-search.component.scss']
})
export class SaleSearchComponent implements OnInit, OnDestroy {
  public isOnline: any;
  public loading = false;
  public subscription: Subscription;
  public err: string; public err_validation: boolean = false;
  public err_internet_text: string; public err_internet_validation: boolean;
  public server: string = this.serverService.get_server();
  public lang: any = 1;
  public request_search: number;
  public tax_search: number;
  public list_floor: any = []; public floor_search: any = []; public floor_searched: any = [];
  public list_year: any = []; public year_search: any = []; public year_searched: any = [];
  public list_crater: any = []; public crater_search: any = []; public crater_searched: any = [];
  public list_type_ceil: any = []; public type_ceil_search: any = []; public type_ceil_searched: any = [];
  public list_install_run_position: any = []; public install_run_position_search: any = []; public install_run_position_searched: any = [];
  public list_install_site: any = []; public install_site_search: any = []; public install_site_searched: any = [];
  public list_install_open_crater: any = []; public install_open_crater_search: any = []; public install_open_crater_searched: any = [];
  public list_install_height: any = []; public install_height_search: any = []; public install_height_searched: any = [];
  public list_install_place: any = []; public install_place_search: any = []; public install_place_searched: any = [];
  public list_sale_process: any = []; public sale_process_search: any = []; public sale_process_searched: any = [];

  floor: any = [];
  year: any = [];
  crater: any = [];
  type_ceil: any = [];
  install_run_position: any = [];
  install_site: any = [];
  open_crater: any = [];
  install_height: any = [];
  install_place: any = [];
  process: any = [];
  search_array: any = [];
  code_factor: number;
  price: number;

  public type_user: any;
  public list_supplier: any = [];
  list_requester: any = [];
  public supplier_title_search_modal: any = [];
  public requester_title_search_modal: any = [];
  public obj_search_supplier: any;
  public supplier_title: any;
  public supplier_id: any;
  public supplier_contract_id: any;
  public requester_title: any;
  public requester_id: any;
  public payment: number;
  public actual_search_than: string;
  public actual_search_until: string;
  cate_text: string;
  export_code: any;
  site: any;
  show_excell: any;
  waiting_excell: any;
  user: string;
  user_title: string;

  @ViewChild('modalRequesterSearch', { static: true }) modalRequesterSearch: any;
  @ViewChild('modalSupplierSearch', { static: true }) modalSupplierSearch: any;
  not_budget: any;
  list_percent: any = []; percent: number;
  list_bullet: any = []; bullet: number;



  constructor(public serverService: ServerService, public router: Router, public matSnackBar: MatSnackBar,
    public dialogRef: MatDialogRef<SaleSearchComponent>, @Inject(MAT_DIALOG_DATA) public dialog_data: any
    , private matDialogRef: MatDialogRef<SaleSearchComponent>
    , private dialog: MatDialog) {
    /************* */

    if (dialog_data) {
      if (dialog_data.search_array.user_title) {
        this.user_title = dialog_data.search_array.user_title;
        this.user = dialog_data.search_array.user;
      }
      if (dialog_data.search_array.code_factor) this.code_factor = dialog_data.search_array.code_factor;
      if (dialog_data.search_array.price) this.price = dialog_data.search_array.price;
      if (dialog_data.search_array.percent) this.percent = dialog_data.search_array.percent;
      if (dialog_data.search_array.bullet) this.bullet = dialog_data.search_array.bullet;
      if (dialog_data.search_array.year) this.year = dialog_data.search_array.year;
      if (dialog_data.search_array.floor) this.floor = dialog_data.search_array.floor;
      if (dialog_data.search_array.crater) this.crater = dialog_data.search_array.crater;
      if (dialog_data.search_array.type_ceil) this.type_ceil = dialog_data.search_array.type_ceil;
      if (dialog_data.search_array.install_run_position) this.install_run_position = dialog_data.search_array.install_run_position;
      if (dialog_data.search_array.install_site) this.install_site = dialog_data.search_array.install_site;
      if (dialog_data.search_array.open_crater) this.open_crater = dialog_data.search_array.open_crater;
      if (dialog_data.search_array.install_height) this.install_height = dialog_data.search_array.install_height;
      if (dialog_data.search_array.install_place) this.install_place = dialog_data.search_array.install_place;
      if (dialog_data.search_array.process) this.process = dialog_data.search_array.process;
      console.log(this.year);
    }

  }//end consructor

  ngOnInit() {
    this.recieve_year();
    this.recieve_floor();
    this.recieve_crater();
    this.recieve_type_ceil();
    this.recieve_install_run_position();
    this.recieve_install_site();
    this.recieve_install_open_crater();
    this.recieve_install_height();
    this.recieve_install_place();
    this.recieve_status();
    this.recieve_sale_process();
  }

  search(excel) {
    this.matDialogRef.close({
      code_factor: this.code_factor,
      year: this.year,
      floor: this.floor,
      price: this.price,
      percent: this.percent,
      bullet: this.bullet,
      crater: this.crater,
      type_ceil: this.type_ceil,
      install_run_position: this.install_run_position,
      install_site: this.install_site,
      open_crater: this.open_crater,
      install_height: this.install_height,
      install_place: this.install_place,
      user_title: this.user_title,
      user: this.user,
      process: this.process,
      export_excel: excel
    })
  }


  //****************************************************** */
  recieve_install_place() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 1511 }).subscribe(
      (res: any) => {
        this.list_install_place = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_install_place.push(res['result'][i]);
          }//end for
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }//end recieve_install_place

  load_services(id) {
    const dialogRef = this.dialog.open(ModulesComponent, {
      width: '40rem',
      height: 'auto',
      disableClose: true,
      data: { id: id }
    });

    dialogRef.afterClosed().subscribe(
      (res) => {
        if (res) {
          this.user = res.id;
          this.user_title = res.title;

        }
      })
  }

  reset_input(id) {
    this.user = "";
    this.user_title = "";
  }

  select_install_place_search() {
    this.install_place = [];
    var install_place = <any>document.getElementsByName("install_place_search[]");
    for (var i = 0; i < install_place.length; i++) {
      if (install_place[i].checked == true) {
        this.install_place.push(install_place[i].value);
      }
    }
    this.install_place = this.install_place.map((items) => {
      return parseInt(items);
    })
  }//end recieve_install_place
  //************************************************************************************* */
  recieve_status() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 2 }).subscribe(
      (res) => {
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_percent.push(res['result'][i]);
            this.list_bullet.push(res['result'][i]);
          }//end for
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }//end recieve_data
  //************************************************************************************* */
  recieve_sale_process() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 1512 }).subscribe(
      (res: any) => {
        this.list_sale_process = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_sale_process.push(res['result'][i]);
          }//end for
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }//end recieve_sale_process

  select_sale_process_search() {
    this.process = [];
    var process = <any>document.getElementsByName("process_search[]");
    for (var i = 0; i < process.length; i++) {
      if (process[i].checked == true) {
        this.process.push(process[i].value);
      }
    }
    this.process = this.process.map((items) => {
      return parseInt(items);
    })
  }//end recieve_sale_process

  //************************************************************************************* */
  recieve_install_open_crater() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 1509 }).subscribe(
      (res: any) => {
        this.list_install_open_crater = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_install_open_crater.push(res['result'][i]);
          }//end for
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }//end recieve_install_open_crater

  select_install_open_crater_search() {
    this.open_crater = [];
    var open_crater = <any>document.getElementsByName("install_open_crater_search[]");
    for (var i = 0; i < open_crater.length; i++) {
      if (open_crater[i].checked == true) {
        this.open_crater.push(open_crater[i].value);
      }
    }
    this.open_crater = this.open_crater.map((items) => {
      return parseInt(items);
    });
  }//end recieve_install_open_crater
  //*********************************************************************** */
  recieve_install_height() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 1510 }).subscribe(
      (res: any) => {
        this.list_install_height = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_install_height.push(res['result'][i]);
          }//end for
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }//end recieve_install_height

  select_install_height_search() {
    this.install_height = [];
    var install_height_search = <any>document.getElementsByName("install_height_search[]");
    for (var i = 0; i < install_height_search.length; i++) {
      if (install_height_search[i].checked == true) {
        this.install_height.push(install_height_search[i].value);
      }
    }
    this.install_height = this.install_height.map((items) => {
      return parseInt(items);
    });
    console.log(this.install_height);
  }//end recieve_install_height
  //****************************************************** */
  recieve_install_site() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 1508 }).subscribe(
      (res: any) => {
        this.list_install_site = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_install_site.push(res['result'][i]);
          }//end for
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }//end recieve_install_site

  select_install_site_search() {
    this.install_site = [];
    var install_site = <any>document.getElementsByName("install_site_search[]");
    for (var i = 0; i < install_site.length; i++) {
      if (install_site[i].checked == true) {
        this.install_site.push(install_site[i].value);
      }
    }
    this.install_site = this.install_site.map((items) => {
      return parseInt(items);
    });
  }//end recieve_install_site
  /****************************************************************************************** */
  recieve_install_run_position() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 1507 }).subscribe(
      (res: any) => {
        this.list_install_run_position = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_install_run_position.push(res['result'][i]);
          }//end for
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }//end recieve_install_run_position

  select_install_run_position_search() {
    this.install_run_position = [];
    var install_run_position = <any>document.getElementsByName("install_run_position_search[]");
    for (var i = 0; i < install_run_position.length; i++) {
      if (install_run_position[i].checked == true) {
        this.install_run_position.push(install_run_position[i].value);
      }
    }
    this.install_run_position = this.install_run_position.map((items) => {
      return parseInt(items);
    });
  }//end recieve_install_run_position



  //****************************************************** */
  recieve_floor() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 263 }).subscribe(
      (res: any) => {
        this.list_floor = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_floor.push(res['result'][i]);
          }//end for
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }//end recieve_floor

  select_floor_search() {
    this.floor = [];
    var floor = <any>document.getElementsByName("floor_search[]");
    for (var i = 0; i < floor.length; i++) {
      if (floor[i].checked == true) {
        this.floor.push(floor[i].value);
      }
    }
    this.floor = this.floor.map((items) => {
      return parseInt(items);
    })
  }//end recieve_floor
  //*********************************************************************** */
  recieve_year() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 1514 }).subscribe(
      (res: any) => {
        this.list_year = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_year.push(res['result'][i]);
          }//end for
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }//end recieve_year

  select_year_search() {
    this.year = [];
    var year = <any>document.getElementsByName("year_search[]");
    for (var i = 0; i < year.length; i++) {
      if (year[i].checked == true) {
        this.year.push(year[i].value);
      }
    }
    this.year = this.year.map((items) => {
      return parseInt(items);
    })
  }//end recieve_year
  //*********************************************************************** */
  recieve_crater() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 1505 }).subscribe(
      (res: any) => {
        this.list_crater = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_crater.push(res['result'][i]);
          }//end for
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }//end recieve_data
  //*********************************************************************** */
  select_crater_search() {
    this.crater = [];
    var crater = <any>document.getElementsByName("crater_search[]");
    for (var i = 0; i < crater.length; i++) {
      if (crater[i].checked == true) {
        this.crater.push(crater[i].value);
      }
    }
    this.crater = this.crater.map((items) => {
      return parseInt(items);
    });
  }//end select_crater_search

  recieve_type_ceil() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 1506 }).subscribe(
      (res: any) => {
        this.list_type_ceil = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_type_ceil.push(res['result'][i]);
          }//end for
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }//end recieve_type_ceil

  select_type_ceil_search() {
    this.type_ceil = [];
    var type_ceil = <any>document.getElementsByName("type_ceil_search[]");
    for (var i = 0; i < type_ceil.length; i++) {
      if (type_ceil[i].checked == true) {
        this.type_ceil.push(type_ceil[i].value);
      }
    }
    this.type_ceil = this.type_ceil.map((items) => {
      return parseInt(items);
    });
  }//end recieve_type_ceil
  //*********************************************************************** */
  close() {
    this.dialogRef.close();
  }
  //**************************************************
  recieve_message(validation: boolean, en_message: string, pe_message: string, type: number, en_action: string, pe_action: string) {
    this.err_internet_validation = false;
    if (type == 1) this.loading = false;
    if (validation == true) {
      if (this.lang == 1) this.matSnackBar.open(pe_message, pe_action, { duration: 2000 });
      if (this.lang == 2) this.matSnackBar.open(en_message, en_action, { duration: 2000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}




